<template>
  <div>
    <div
      :class="{ holder: displayButton, 'address-collection': !displayButton }"
    >
      <template v-if="loadingProject === status.LOADED">
        <div class="campaign-card">
          <div>
            <div class="campaign-card-header">
              <h4 class="campaign-title">{{ projectTitle }}</h4>
              <p
                class="campaign-subtitle inter"
                v-if="projectInfo.enableCustomSubheading"
              >
                {{
                  projectInfo.adminOrderSubheading ||
                    `Complete form to receive a gift from ${projectInfo.teamName}.`
                }}
              </p>
              <p class="campaign-subtitle inter" v-else>
                Complete form to receive a gift from {{ projectInfo.teamName }}.
              </p>
            </div>

            <div class="campaign-card-body">
              <div class="campaing-card-indicators">
                <div class="campaing-card-indicators-item active"></div>
                <div class="campaing-card-indicators-item active"></div>
              </div>
              <div class="campaign-subtitle-container">
                <p class="campaign-subtitle inter">Shipping information</p>
              </div>

              <div class="card-header">
                <div>
                  <p class="message">
                    Shipping address

                    <span>
                      This information will be used by our carriers for
                      logistics purposes only
                    </span>
                  </p>
                </div>
              </div>

              <section class="form-region">
                <!-- Form Here -->
                <section class="region-holder">
                  <div class="form-holder">
                    <!-- Email Here -->
                    <div class="relative">
                      <input
                        type="email"
                        id="email"
                        placeholder="Email"
                        class="form-control"
                        v-model="recipientInfo.email"
                        :class="{ input__error: $v.recipientInfo.email.$error }"
                      />
                      <span
                        class="error-message-info"
                        v-if="$v.recipientInfo.email.$error"
                        >{{
                          !$v.recipientInfo.email.email
                            ? 'Please enter a valid email.'
                            : 'Email is required.'
                        }}</span
                      >
                    </div>

                    <!-- Name Here -->
                    <div class="relative">
                      <input
                        autocomplete="off"
                        type="text"
                        id="name"
                        class="form-control"
                        placeholder="Full name"
                        v-model="recipientInfo.name"
                        :class="{ input__error: $v.recipientInfo.name.$error }"
                      />
                      <span
                        class="error-message-info"
                        v-if="$v.recipientInfo.name.$error"
                        >{{
                          !$v.recipientInfo.name.isValidRegex
                            ? 'Only latin characters are allowed.'
                            : 'Name is required.'
                        }}
                      </span>
                    </div>

                    <!-- Phone Here -->
                    <div
                      class="phone-group single relative placeholder-capitalize"
                    >
                      <vue-tel-input
                        placeholder="Phone"
                        defaultCountry="US"
                        :autoDefaultCountry="false"
                        class="form-control "
                        v-model="recipientInfo.phone"
                        :class="{ input__error: $v.recipientInfo.phone.$error }"
                        :inputOptions="inputOptions"
                      >
                        <template #arrow-icon>
                          <Dropdown />
                        </template>
                      </vue-tel-input>
                      <span
                        class="error-message-info"
                        v-if="$v.recipientInfo.phone.$error"
                        >Phone is required.</span
                      >
                    </div>

                    <!-- Country here -->
                    <div
                      class="country-holder"
                      :class="{ input__error: $v.recipientInfo.country.$error }"
                    >
                      <CountrySelect
                        placeholder="select shipping country"
                        topCountry="US"
                        v-model="recipientInfo.country"
                        :country="recipientInfo.country"
                        :isCustom="true"
                        :class="{
                          input__error: $v.recipientInfo.country.$error
                        }"
                      />
                    </div>

                    <!-- Address One here -->
                    <div class="relative">
                      <input
                        type="text"
                        name="project_address_one"
                        id="address_one"
                        placeholder="Address 1*"
                        class="form-control"
                        v-model="recipientInfo.addressOne"
                        @input.once="handleAddressInput()"
                        :class="{
                          input__error: $v.recipientInfo.addressOne.$error
                        }"
                      />
                      <span
                        class="error-message-info"
                        v-if="$v.recipientInfo.addressOne.$error"
                        >{{
                          !$v.recipientInfo.addressOne.isValidRegex
                            ? 'Only latin characters are allowed.'
                            : 'Address is required.'
                        }}</span
                      >
                    </div>

                    <!-- Address two -->
                    <div class="relative">
                      <input
                        autocomplete="off"
                        placeholder="Apt/Suite"
                        type="text"
                        id="address_two"
                        class="form-control"
                        @input="
                          checkAddressLimit('recipientInfo', 'addressTwo')
                        "
                        v-model="recipientInfo.addressTwo"
                        :class="{
                          input__error: $v.recipientInfo.addressTwo.$error
                        }"
                      />
                      <span
                        class="error-message-info"
                        v-if="$v.recipientInfo.addressTwo.$error"
                        >Only latin characters are allowed.</span
                      >
                    </div>

                    <!-- City - state - zipcode here -->
                    <div class="flex items-center">
                      <!-- City Here -->
                      <div class="w-1/3 relative">
                        <input
                          type="text"
                          id="city"
                          placeholder="City*"
                          class="form-control first"
                          autocomplete="new-password"
                          v-model="recipientInfo.city"
                          :class="{
                            input__error: $v.recipientInfo.city.$error
                          }"
                        />
                        <span
                          class="error-message-info bottom"
                          v-if="$v.recipientInfo.city.$error"
                          >{{
                            !$v.recipientInfo.city.isValidRegex
                              ? 'Only latin characters are allowed.'
                              : 'City is required.'
                          }}</span
                        >
                      </div>

                      <!-- State Here -->
                      <div
                        class="w-1/3 country-holder state relative"
                        :class="{ input__error: $v.recipientInfo.state.$error }"
                      >
                        <RegionSelect
                          placeholder=" state"
                          :isCustom="true"
                          v-model="recipientInfo.state"
                          :country="recipientInfo.country"
                          :region="recipientInfo.state"
                          :class="{
                            input__error: $v.recipientInfo.state.$error
                          }"
                        />
                        <span
                          class="error-message-info bottom"
                          v-if="$v.recipientInfo.state.$error"
                          >State is required.</span
                        >
                      </div>

                      <!-- Zipcode Here -->
                      <div class="w-1/3 relative">
                        <input
                          type="text"
                          id="zipcode"
                          placeholder="Zipcode*"
                          class="form-control"
                          autocomplete="new-password"
                          v-model="recipientInfo.zipcode"
                          :class="{
                            input__error: $v.recipientInfo.zipcode.$error
                          }"
                        />
                        <span
                          class="error-message-info bottom"
                          v-if="$v.recipientInfo.zipcode.$error"
                          >{{
                            !$v.recipientInfo.zipcode.isValidRegex
                              ? 'Only latin characters are allowed.'
                              : 'Zipcode is required.'
                          }}</span
                        >
                      </div>
                    </div>
                  </div>
                  <div class="button-region flex">
                    <button
                      v-if="projectInfo.products.length"
                      class="button-gemnote button-gemnote--small edit"
                      @click="handleBack"
                    >
                      <span>back</span>
                    </button>
                    <button
                      class="button-gemnote button-gemnote--small"
                      @click="handleRoute"
                      :disabled="pendingSubmission"
                    >
                      <span>{{
                        projectInfo.products.length ? 'next' : 'submit'
                      }}</span>
                    </button>
                  </div>
                </section>
              </section>
            </div>
          </div>
        </div>

        <!-- Form region here -->
      </template>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { email, required, helpers } from 'vuelidate/lib/validators'
import { layouts, status } from '@/helpers'
import Dropdown from '@/components/Universal/Dropdown.vue'
import CountrySelect from '@/components/CustomizedComponents/CountrySelect'
import RegionSelect from '@/components/CustomizedComponents/RegionSelect'
import AddressLimitMixin from '../../mixins/AddressLimit'
let autocomplete
const recaptchaScript = document.createElement('script')
recaptchaScript.setAttribute(
  'src',
  `https://maps.googleapis.com/maps/api/js?libraries=places&key=${process.env.VUE_APP_MAPS_API_KEY}`
)
document.head.appendChild(recaptchaScript)

export default {
  mixins: [AddressLimitMixin],
  components: {
    Dropdown,
    CountrySelect,
    RegionSelect
  },

  validations: {
    recipientInfo: {
      name: {
        required,
        isValidRegex: helpers.regex(
          'matches',
          /^[A-Za-z0-9äöüÄÖÜß .,?!;:'(){}[\]/\\&%@#_$*+=<>^-]+$/
        )
      },
      email: { required, email },
      phone: {
        required,
        isValidRegex: helpers.regex(
          'matches',
          /^\+?(\d{1,3})?[-.\s]?(\(?\d{1,4}?\)?[-.\s]?)?[\d-.\s]{3,15}$/
        )
      },
      country: { required },
      addressOne: {
        required,
        isValidRegex: helpers.regex(
          'matches',
          /^[A-Za-z0-9äöüÄÖÜß .,?!;:'(){}[\]/\\&%@#_$*+=<>^-]+$/
        )
      },
      addressTwo: {
        isValidRegex: helpers.regex(
          'matches',
          /^[A-Za-z0-9äöüÄÖÜß .,?!;:'(){}[\]/\\&%@#_$*+=<>^-]+$/
        )
      },
      city: {
        required,
        isValidRegex: helpers.regex(
          'matches',
          /^[A-Za-z0-9äöüÄÖÜß .,?!;:'(){}[\]/\\&%@#_$*+=<>^-]+$/
        )
      },
      state: { required },
      zipcode: {
        required,
        isValidRegex: helpers.regex(
          'matches',
          /^[A-Za-z0-9äöüÄÖÜß .,?!;:'(){}[\]/\\&%@#_$*+=<>^-]+$/
        )
      }
    }
  },
  props: ['uuid'],
  data: () => ({
    pendingSubmission: false,
    inputOptions: {
      id: 'phone',
      placeholder: 'Phone'
    }
  }),

  computed: {
    status() {
      return status
    },
    projectTitle() {
      return (
        (this.projectInfo &&
          this.projectInfo.enableCustomTitle &&
          this.projectInfo.adminOrderTitle) ||
        "Hurray! You're getting a gift."
      )
    },

    projectDescription() {
      if (Object.keys(this.projectInfo).length) {
        if (
          this.projectInfo.enableCustomDescription &&
          this.projectInfo.adminOrderDescription
        ) {
          return this.projectInfo.adminOrderDescription
        } else {
          return `You've been invited by ${this.projectInfo.teamName} to submit your
              information to receive swag or a special gift.`
        }
      }
      return ''
    },
    ...mapState({
      recipientInfo: state => state.project.recipientInfo,
      projectInfo: state => state.project.projectInfo,
      loadingProject: state => state.project.loadingProjectLinkInfo
    }),

    displayButton() {
      return (
        this.projectInfo &&
        this.projectInfo.products &&
        this.projectInfo.products.length
      )
    }
  },

  created() {
    this.$store.dispatch('layout/setPageLayout', layouts.ADDRESS_COLLECTION)
    this.$store.dispatch('project/getProjectLinkInfo', {
      projectId: this.uuid,
      redirect: false
    })
    let projectRecipientInfo = localStorage.getItem('projectRecipientInfo')
    if (projectRecipientInfo) {
      const parsedInfo = JSON.parse(projectRecipientInfo)
      this.$store.commit('project/UPDATE_RECIPIENT_INFO', parsedInfo)
    }
  },
  watch: {
    'recipientInfo.addressOne'() {
      this.checkAddressLimit('recipientInfo', 'addressOne')
    }
  },
  methods: {
    handleAddressInput() {
      this.handleSearchField('project_address_one')
    },
    async handleRoute() {
      this.$v.recipientInfo.$touch()

      if (this.$v.recipientInfo.$error) {
        return
      }

      if (this.projectInfo.products.length) {
        this.$router.push({ name: 'AddressCollectionReview' })
        localStorage.setItem(
          'projectRecipientInfo',
          JSON.stringify(this.recipientInfo)
        )
      } else {
        this.pendingSubmission = true
        await this.$store.dispatch('project/confirmRecipientInfo', this.uuid)
        this.pendingSubmission = false
      }
    },
    handleBack() {
      this.$router.push({
        name: 'ProjectItemsSelection',
        params: { id: this.uuid }
      })
    },

    handleSearchField(selector) {
      const google = window.google
      const input = document.querySelector(`[name = ${selector}]`)
      if (input) {
        autocomplete = new google.maps.places.Autocomplete(input, {
          fields: ['formatted_address', 'address_components'],
          types: ['address']
        })
        autocomplete.addListener('place_changed', this.fillInAddress)
      }
    },

    fillInAddress() {
      if (autocomplete) {
        const place = autocomplete.getPlace()

        this.recipientInfo.addressOne = ''

        for (const component of place.address_components) {
          const componentType = component.types[0]

          switch (componentType) {
            case 'street_number': {
              this.recipientInfo.addressOne += `${component.long_name} `
              break
            }

            case 'route': {
              this.recipientInfo.addressOne += component.long_name
              break
            }

            case 'country': {
              this.recipientInfo.country = component.short_name
              break
            }

            case 'administrative_area_level_1': {
              this.recipientInfo.state = component.short_name
              break
            }

            case 'locality': {
              this.recipientInfo.city = component.long_name
              break
            }

            case 'postal_code': {
              this.recipientInfo.zipcode = component.long_name
              break
            }

            default: {
              break
            }
          }
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/global.scss';
.title {
  font-size: 32px;
}
.bold {
  font-weight: bold !important;
}
.description {
  display: flex;
  justify-content: center;
}

.campaign-container {
  height: auto;
  margin: 0 auto;
}

.campaign-card {
  min-width: 100%;
  margin: 0 auto;
  padding: 2rem 0rem;
  padding-bottom: 8rem;
}

.campaign-card-body {
  margin: 1.5rem 0;
  border: 1px solid $main-5;
  border-radius: 1rem;
  padding: 2rem 0;

  .campaign-subtitle-container {
    border-bottom: 1px solid $main-5;
    padding-bottom: 3.5rem;
  }

  .campaign-subtitle {
    font-weight: 700;
    font-size: 1.563rem;
    text-align: center;
  }

  .campaing-card-indicators {
    display: flex;
    gap: 1rem;
    align-items: center;
    justify-content: center;
    margin-bottom: 2rem;

    .campaing-card-indicators-item {
      width: 44px;
      height: 5px;
      border-radius: 100px;
      background-color: $main-1;
      cursor: pointer;

      &.active {
        background-color: $main-5;
      }
    }
  }
}

.campaign-card-header {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 1.5rem;

  @media (max-width: 575.98px) {
    justify-content: center;
    flex-direction: column;
    width: 100%;
    gap: 1rem;
  }

  .campaign-subtitle {
    font-size: 0.938rem;
    text-align: left;
  }
}

.campaign-title {
  font-family: 'Editorial New';
  font-size: 2.5rem;
  font-weight: normal;
  text-align: left;
}

.campaign-subtitle {
  font-size: 1rem;
  text-align: center;
}

.address-collection {
  // width: 85%;
  margin: auto;
  padding-bottom: 2rem;

  .form-region {
    padding-bottom: 5rem;
    margin: auto;
    padding-top: 0.25rem;

    .text {
      text-align: center;
      margin-bottom: 3rem;
      text-align: center;
      p {
        font-weight: normal;
      }
    }

    @media (max-width: 575.98px) {
      width: 100%;
    }

    @media (min-width: 576px) and (max-width: 767.98px) {
      width: 100%;
    }
  }
}
.campaign-title {
  font-family: 'Editorial New';
  font-size: 2rem;
  // margin-bottom: 1rem;
  font-weight: normal;
}
.campaign-subtitle {
  font-size: 1rem;
  text-align: center;
}
.holder {
  width: 100%;
  margin: auto;
  // padding: 4rem 0;

  .form-region {
    padding-bottom: 5rem;
    margin: auto;
    padding-top: 0.25rem;

    .text {
      text-align: center;
      margin-bottom: 3rem;
      text-align: center;
      p {
        font-weight: normal;
      }
    }

    @media (max-width: 575.98px) {
      width: 100%;
    }

    @media (min-width: 576px) and (max-width: 767.98px) {
      width: 100%;
    }
  }
}

.region-holder {
  width: 30%;
  margin: auto;

  .button-region {
    margin-top: 2.5rem;
    width: 100%;
    justify-content: center;
    align-items: center;
    gap: 0.8rem;

    button {
      padding: 1rem 2.5rem !important;
      height: 2.8rem !important;

      &.edit {
        background-color: transparent !important;
        color: #232220 !important;
      }
    }
  }

  @media (max-width: 575.98px) {
    width: 90%;
  }

  @media (min-width: 576px) and (max-width: 767.98px) {
    width: 100%;
  }

  .form-holder {
    margin-top: 2rem;
    border: 1px solid $main-6;
    border-bottom: none;

    input {
      font-size: 0.875rem;
      font-weight: normal;
      font-family: $inter;
      padding: 0 1.5rem;
      height: 56px;

      &.input__error {
        border-bottom: 1px solid $gem-terraorange !important;
      }

      &::placeholder {
        color: #a09c95;
        font-size: 0.813rem;
      }
    }

    .country-holder {
      padding: 0.75rem 1.5rem;
      border-bottom: 1px solid $main-6;

      &.input__error {
        border-bottom: 1px solid $gem-terraorange;
      }

      &.state {
        padding: 0.469rem 0.5rem;
        border: 1px solid $main-6;
        border-top: none;

        &.input__error {
          border-bottom: 1px solid $gem-terraorange;
        }
      }
    }
  }
}

.button-region {
  width: 60%;

  @media (max-width: 575.98px) {
    width: 80%;
  }

  @media (min-width: 576px) and (max-width: 767.98px) {
    width: 80%;
  }
  .button-gemnote {
    height: 2.5rem;
    width: auto;
    padding: 0 2rem;

    &:disabled {
      opacity: 0.5;
      cursor: not-allowed;
    }
  }
}

.card-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid $main-5;
  padding: 1rem 2rem;

  @media (max-width: 575.98px) {
    padding: 1rem;
  }

  .message {
    text-align: left;
    font-weight: bold;
    font-size: 0.938rem;
    span {
      font-weight: normal;
      padding-left: 0.5rem;
    }
  }
}

.error-message-info {
  position: absolute;
  bottom: 0;
  right: 1%;
  font-size: 10px;
  color: #da5737;

  &.bottom {
    top: 100%;
    left: 0;
  }
}
</style>
